// extracted by mini-css-extract-plugin
export default {"container":"Solutions_container__hhggS","category":"Solutions_category__FULYM","title":"Solutions_title__bm8h-","items":"Solutions_items__Jw3ch","item":"Solutions_item__kV9VX"};